import DOMPurify from "dompurify";

/**
 * Sanitize server-rendered HTML before insertion via dangerouslySetInnerHTML.
 * Allows the same tags that our markdown→HTML pipeline produces (h1–h6, p,
 * ul/ol/li, strong/em, a, code/pre, blockquote, hr, table-block) and strips
 * anything else (scripts, event-handlers, javascript: URLs, etc.).
 */
export const sanitizeHtml = (raw) => {
  if (!raw) return "";
  return DOMPurify.sanitize(String(raw), {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ["style", "script", "iframe", "form", "input", "object", "embed"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
  });
};
